import { projectStorage } from '../firebase/config'
import { ref } from 'vue'
import getUser from "@/composable/getUser";


const useStorage = () => {
    const isPanding = ref(false)

    const { user } = getUser()

    const error = ref(null)         // Error Xatoliklar uchun
    const url = ref(null)          // Rasmlarni Url Manzillari uchun
    const filePath = ref(null)      // File Yon'nalishlarini tizimlash uchun
    const isPending = ref(null)

    const uploadImage = async (file) => {
        isPending.value = true
        filePath.value = `covers/${user.value.uid}/${file.name}`
        const storageRef = projectStorage.ref(filePath.value)       // fayl saqlash tizimini storagega bildirish!
        try {
            const res = await storageRef.put(file)      // url qiymat qaytadi
            url.value = await res.ref.getDownloadURL();
            isPending.value = false
        } catch (err) {
            console.log(err.message)
            error.value = err.message
            isPending.value = false
        }
    }

    const deleteImage = async (path) => {
        isPending.value = true
        const storageRef = projectStorage.ref(path)

        try {
            await storageRef.delete()
            isPending.value = false
        } catch (err) {
            console.log(err.message)
            error.value = err.message
            isPending.value = false
        }
    }
    return {
        url,
        filePath,
        uploadImage,
        error,
        deleteImage,
        isPending
    }
}

export default useStorage;